<template>
	<div>
		<v-layout row wrap>
			<v-flex xs12 sm12 md6 lg6 v-for="event in events" :key="event.pk">
				<event-list-item :event="event"></event-list-item>
			</v-flex>
		</v-layout>
		<div v-if="getFilteredEvents.length === 0">
			<h5>Sorry, no results with these filters.</h5>
			<v-btn @click="clearEventFilters(['date', 'min_price', 'max_price', 'category'])">Clear filters</v-btn>
		</div>
	</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import EventListItem from './EventListItem.vue'
import moment from 'moment'

export default {
	props: ['events'],
	computed: {
		...mapGetters(['getFilteredEvents', 'getFeaturedEvents']),
		getUniqueDates() {
			const secondsInAWeek = 604800
			var dateList = this.getFilteredEvents.map(event => moment(event.date)) // .map((event) => moment(event.date).format('dddd, MMMM Do'))
			var finalDateList = []
			for (var i = 0; i < dateList.length; i++) {
				if (dateList[i].unix() < dateList[0].unix() + secondsInAWeek * 2) {
					finalDateList.push(dateList[i].format('dddd, MMMM Do'))
				}
			}
			return finalDateList.filter((x, i, a) => a.indexOf(x) === i)
		},
		getFeaturedUniqueDates() {
			var dateList = this.getFeaturedEvents.map(event =>
				moment(event.date).format('dddd, MMMM Do')
			)
			return dateList.filter((x, i, a) => a.indexOf(x) === i)
		}
	},
	methods: {
		...mapActions(['clearEventFilters']),
		formatDate(date) {
			return moment(date).format('dddd, MMMM Do')
		}
	},
	components: {
		EventListItem
	}
}
</script>
